import flagBg from 'assets/flag-bg.svg';
import flagUsa from 'assets/flag-usa.svg';
import { useTranslation } from 'react-i18next';
import { getUserInfo } from 'utils/auth';

const useTrainingMaterials = () => {
  const { t } = useTranslation();
  const userInfo = getUserInfo();
  const isFeatureEmployeeCandidatesActive = userInfo?.featureEmployeeCandidatesIsActive;
  const isCandidate = userInfo?.isCandidate === true;

  const trainingMaterials = {
    employee: {
      pdfs: [
        {
          name: t('trainingMaterials.pdfs.manualBG'),
          url: '/assets/pdfs/employeeManualBG.pdf',
          icon: flagBg,
          language: 'bg',
        },
        {
          name: t('trainingMaterials.pdfs.moduleLeaves'),
          url: '/assets/pdfs/moduleleaves-employee.pdf',
          icon: 'FaCalendarPdf',
          language: 'bg',
        },
        {
          name: t('trainingMaterials.pdfs.manualEN'),
          url: '/assets/pdfs/employeeManualEN.pdf',
          icon: flagUsa,
          language: 'both',
        },
      ],
      videos: [
        ...(isFeatureEmployeeCandidatesActive && isCandidate
          ? [
              {
                url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D1%81%D0%BB%D1%83%D0%B6%D0%B8%D1%82%D0%B5%D0%BB%D0%B8/0.1%20%D0%9A%D0%B0%D0%BD%D0%B4%D0%B8%D0%B4%D0%B0%D1%82%D0%B8%20-%20%D0%BF%D0%BE%D0%B4%D0%B0%D0%B2%D0%B0%D0%BD%D0%B5%20%D0%B4%D0%B0%D0%BD%D0%BD%D0%B8%20%D0%B7%D0%B0%20%D0%BA%D0%B0%D0%BD%D0%B4%D0%B8%D0%B4%D0%B0%D1%82%D1%83%D1%80%D0%B0%20%D0%BA%D1%8A%D0%BC%20eHR.mp4',
                title: 'Кандидат - начало Етап 1',
                description: 'Подаване на кандидатура и информация за началото на процеса като кандидат.',
              },
              {
                url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D1%81%D0%BB%D1%83%D0%B6%D0%B8%D1%82%D0%B5%D0%BB%D0%B8/0.2%20%D0%9A%D0%B0%D0%BD%D0%B4%D0%B8%D0%B4%D0%B0%D1%82%D0%B8%20-%20%D0%BF%D1%80%D0%B5%D0%BC%D0%B8%D0%BD%D0%B0%D0%B2%D0%B0%D0%BD%D0%B5%20%D0%BF%D1%80%D0%B5%D0%B7%20%D0%BF%D1%80%D0%BE%D1%86%D0%B5%D1%81%20%D0%B2%20eHR.mp4',
                title: 'Кандидат - край Етап 1 и Етап 2',
                description:
                  'Подписване споразумение за електронна обмяна, попълване Форма за кандидастване и предоставяне на документи за Етап 2.',
              },
            ]
          : []),
        {
          url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D1%81%D0%BB%D1%83%D0%B6%D0%B8%D1%82%D0%B5%D0%BB%D0%B8/1.%20%D0%90%D0%BA%D1%82%D0%B8%D0%B2%D0%B8%D1%80%D0%B0%D0%BD%D0%B5%20%D0%BD%D0%B0%20%D0%B0%D0%BA%D0%B0%D1%83%D0%BD%D1%82%20%28eHR%29.mp4',
          title: t('trainingMaterials.videos.employee.accountActivation.title'),
          description: t('trainingMaterials.videos.employee.accountActivation.description'),
        },
        {
          url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D1%81%D0%BB%D1%83%D0%B6%D0%B8%D1%82%D0%B5%D0%BB%D0%B8/2.%20%D0%90%D0%BA%D1%82%D0%B8%D0%B2%D0%B8%D1%80%D0%B0%D0%BD%D0%B5%20%D0%BD%D0%B0%20%D0%B4%D0%B2%D1%83%D1%84%D0%B0%D0%BA%D1%82%D0%BE%D1%80%D0%BD%D0%B0%20%D0%B0%D1%83%D1%82%D0%B5%D0%BD%D1%82%D0%B8%D0%BA%D0%B0%D1%86%D0%B8%D1%8F%20%28eHR%29.mp4',
          title: t('trainingMaterials.videos.employee.enableTwoFA.title'),
          description: t('trainingMaterials.videos.employee.enableTwoFA.description'),
        },
        {
          url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D1%81%D0%BB%D1%83%D0%B6%D0%B8%D1%82%D0%B5%D0%BB%D0%B8/3.%20%D0%97%D0%B0%D1%8F%D0%B2%D1%8F%D0%B2%D0%B0%D0%BD%D0%B5%20%D0%BD%D0%B0%20%D0%BE%D1%82%D1%81%D1%8A%D1%81%D1%82%D0%B2%D0%B8%D0%B5%20%28eHR%29.mp4',
          title: t('trainingMaterials.videos.employee.requestLeave.title'),
          description: t('trainingMaterials.videos.employee.requestLeave.description'),
        },
        {
          url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D1%81%D0%BB%D1%83%D0%B6%D0%B8%D1%82%D0%B5%D0%BB%D0%B8/4.%20%D0%9E%D0%B4%D0%BE%D0%B1%D1%80%D1%8F%D0%B2%D0%B0%D0%BD%D0%B5%20%D0%B8%20%D0%BF%D0%BE%D0%B4%D0%BF%D0%B8%D1%81%D0%B2%D0%B0%D0%BD%D0%B5%20%D0%BD%D0%B0%20%D0%BF%D0%BE%D0%BB%D1%83%D1%87%D0%B5%D0%BD%20%D0%B4%D0%BE%D0%BA%D1%83%D0%BC%D0%B5%D0%BD%D1%82%20%28eHR%29.mp4',
          title: t('trainingMaterials.videos.employee.approvalAndSigningOfDocument.title'),
          description: t('trainingMaterials.videos.employee.approvalAndSigningOfDocument.description'),
        },
        {
          url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D1%81%D0%BB%D1%83%D0%B6%D0%B8%D1%82%D0%B5%D0%BB%D0%B8/5.%20%D0%A1%D1%8A%D0%B7%D0%B4%D0%B0%D0%B2%D0%B0%D0%BD%D0%B5%2C%20%D0%BE%D0%B4%D0%BE%D0%B1%D1%80%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B8%20%D0%BF%D0%BE%D0%B4%D0%BF%D0%B8%D1%81%D0%B2%D0%B0%D0%BD%D0%B5%20%D0%BD%D0%B0%20%D0%B2%D1%8A%D0%BD%D1%88%D0%B5%D0%BD%20%D0%B4%D0%BE%D0%BA%D1%83%D0%BC%D0%B5%D0%BD%D1%82%20%28eHR%29.mp4',
          title: t('trainingMaterials.videos.employee.createApprovalAndSigningOfDocument.title'),
          description: t('trainingMaterials.videos.employee.createApprovalAndSigningOfDocument.description'),
        },
        {
          url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D1%81%D0%BB%D1%83%D0%B6%D0%B8%D1%82%D0%B5%D0%BB%D0%B8/6.%20%D0%A1%D1%8A%D0%B7%D0%B4%D0%B0%D0%B2%D0%B0%D0%BD%D0%B5%2C%20%D0%BE%D0%B4%D0%BE%D0%B1%D1%80%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B8%20%D0%BF%D0%BE%D0%B4%D0%BF%D0%B8%D1%81%D0%B2%D0%B0%D0%BD%D0%B5%20%D0%BD%D0%B0%20%D0%B4%D0%BE%D0%BA%D1%83%D0%BC%D0%B5%D0%BD%D1%82%20%D0%BE%D1%82%20%D1%88%D0%B0%D0%B1%D0%BB%D0%BE%D0%BD%20%28eHR%29.mp4',
          title: t('trainingMaterials.videos.employee.createApprovalAndSigningOfDocumentTemplate.title'),
          description: t('trainingMaterials.videos.employee.createApprovalAndSigningOfDocumentTemplate.description'),
        },
      ],
    },
    employer: {
      pdfs: [
        {
          name: t('trainingMaterials.pdfs.manualBG'),
          url: '/assets/pdfs/employerManualBG.pdf',
          icon: flagBg,
          language: 'bg',
        },
        {
          name: t('trainingMaterials.pdfs.manualEN'),
          url: '/assets/pdfs/employerManualEN.pdf',
          icon: flagUsa,
          language: 'both',
        },
        {
          name: t('trainingMaterials.pdfs.moduleLeaves'),
          url: '/assets/pdfs/moduleleaves-employer.pdf',
          icon: 'FaCalendarPdf',
          language: 'bg',
        },
        {
          name: t('trainingMaterials.pdfs.moduleKep'),
          url: '/assets/pdfs/kep_employer.pdf',
          icon: 'FaPenPfd',
          language: 'bg',
        },
      ],
      videos: [
        {
          url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D0%A0%D0%B0%D0%B1%D0%BE%D1%82%D0%BE%D0%B4%D0%B0%D1%82%D0%B5%D0%BB/%D0%A0%D1%8A%D1%87%D0%BD%D0%BE%20%D0%B4%D0%BE%D0%B1%D0%B0%D0%B2%D1%8F%D0%BD%D0%B5%20%D0%BD%D0%B0%20%D0%BE%D1%82%D0%BF%D1%83%D1%81%D0%BA.mp4',
          title: t('trainingMaterials.videos.employer.addLeaveManually.title'),
          description: t('trainingMaterials.videos.employer.addLeaveManually.description'),
        },
        {
          url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D0%A0%D0%B0%D0%B1%D0%BE%D1%82%D0%BE%D0%B4%D0%B0%D1%82%D0%B5%D0%BB/%D0%A0%D0%B5%D0%B4%D0%B0%D0%BA%D1%86%D0%B8%D1%8F%20%D0%BD%D0%B0%20%D0%BE%D1%82%D0%BF%D1%83%D1%81%D0%BA%D0%B8.mp4',
          title: t('trainingMaterials.videos.employer.editLeave.title'),
          description: t('trainingMaterials.videos.employer.editLeave.description'),
        },
        {
          url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D0%A0%D0%B0%D0%B1%D0%BE%D1%82%D0%BE%D0%B4%D0%B0%D1%82%D0%B5%D0%BB/%D0%94%D0%B8%D0%B3%D0%B8%D1%82%D0%B0%D0%BB%D0%B8%D0%B7%D0%B8%D1%80%D0%B0%D0%BD%D0%B5%20%D0%BD%D0%B0%20%D0%B4%D0%BE%D0%BA%D1%83%D0%BC%D0%B5%D0%BD%D1%82.mp4',
          title: t('trainingMaterials.videos.employer.digitalizePaperDocument.title'),
          description: t('trainingMaterials.videos.employer.digitalizePaperDocument.description'),
        },
        {
          url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D0%A0%D0%B0%D0%B1%D0%BE%D1%82%D0%BE%D0%B4%D0%B0%D1%82%D0%B5%D0%BB/%D0%9C%D0%BD%D0%BE%D0%B6%D0%B5%D1%81%D1%82%D0%B2%D0%B5%D0%BD%D0%BE%20%D1%81%D1%8A%D0%B7%D0%B4%D0%B0%D0%B2%D0%B0%D0%BD%D0%B5%20%D0%BD%D0%B0%20%D0%B4%D0%BE%D0%BA%D1%83%D0%BC%D0%B5%D0%BD%D1%82%D0%B8.mp4',
          title: t('trainingMaterials.videos.employer.bulkDocumentCreation.title'),
          description: t('trainingMaterials.videos.employer.bulkDocumentCreation.description'),
        },
        {
          url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D0%A0%D0%B0%D0%B1%D0%BE%D1%82%D0%BE%D0%B4%D0%B0%D1%82%D0%B5%D0%BB/%D0%9C%D0%B0%D1%81%D0%BE%D0%B2%D0%BE%20%D0%9E%D0%B4%D0%BE%D0%B1%D1%80%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B8%20%D0%BF%D0%BE%D0%B4%D0%BF%D0%B8%D1%81%D0%B2%D0%B0%D0%BD%D0%B5%20%D0%BD%D0%B0%20%D0%BE%D1%82%D0%BF%D1%83%D1%81%D0%BA%D0%B8.mp4',
          title: t('trainingMaterials.videos.employer.massApprovalAndSigning.title'),
          description: t('trainingMaterials.videos.employer.massApprovalAndSigning.description'),
        },
        ...(isFeatureEmployeeCandidatesActive
          ? [
              {
                url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D1%81%D0%BB%D1%83%D0%B6%D0%B8%D1%82%D0%B5%D0%BB%D0%B8/0.1%20%D0%9A%D0%B0%D0%BD%D0%B4%D0%B8%D0%B4%D0%B0%D1%82%D0%B8%20-%20%D0%BF%D0%BE%D0%B4%D0%B0%D0%B2%D0%B0%D0%BD%D0%B5%20%D0%B4%D0%B0%D0%BD%D0%BD%D0%B8%20%D0%B7%D0%B0%20%D0%BA%D0%B0%D0%BD%D0%B4%D0%B8%D0%B4%D0%B0%D1%82%D1%83%D1%80%D0%B0%20%D0%BA%D1%8A%D0%BC%20eHR.mp4',
                title: 'Кандидат - начало Етап 1',
                description: 'Подаване на кандидатура и информация за началото на процеса като кандидат.',
              },
              {
                url: 'https://video-materials-b49f39878f45.ehr.bg/eHR%20%D0%B7%D0%B0%20%D1%81%D0%BB%D1%83%D0%B6%D0%B8%D1%82%D0%B5%D0%BB%D0%B8/0.2%20%D0%9A%D0%B0%D0%BD%D0%B4%D0%B8%D0%B4%D0%B0%D1%82%D0%B8%20-%20%D0%BF%D1%80%D0%B5%D0%BC%D0%B8%D0%BD%D0%B0%D0%B2%D0%B0%D0%BD%D0%B5%20%D0%BF%D1%80%D0%B5%D0%B7%20%D0%BF%D1%80%D0%BE%D1%86%D0%B5%D1%81%20%D0%B2%20eHR.mp4',
                title: 'Кандидат - край Етап 1 и Етап 2',
                description:
                  'Подписване споразумение за електронна обмяна, попълване Форма за кандидастване и предоставяне на документи за Етап 2.',
              },
            ]
          : []),
      ],
    },
  };
  return trainingMaterials;
};

export default useTrainingMaterials;
